import _plugin_vue_export_helper_default from "../_virtual/_plugin-vue_export-helper.js";
import ApprovalSection_vue_vue_type_script_setup_true_lang_default from "./ApprovalSection.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                    */
//#region src/components/ApprovalSection.vue
var ApprovalSection_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ApprovalSection_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-f493d089"]]);
//#endregion
export { ApprovalSection_default as default };

//# sourceMappingURL=ApprovalSection.vue.js.map